<red-asset-view [assetId]="resourceUrl()" [thumbnail]="true"></red-asset-view>
